import { createAsyncIcon } from '../../_factory/createAsyncIcon';

const AsyncPhosphorIconBold = createAsyncIcon(() => import('./PhosphorIconBold'));

export default AsyncPhosphorIconBold;

AsyncPhosphorIconBold.displayName = 'AsyncPhosphorIconBold';
